import * as React from 'react'
import { Route, Routes, useParams } from 'react-router-dom'
import { homeRoutes, homeRoutesMap } from './routes'
import { homePath } from './index'
import { HomeLayout } from './HomeLayout'
import { AppLayoutDahboardWithNav } from '../shared/layouts'
import { ErrorBoundary } from '../shared/components/ErrorBoundary'
import { ErrorFallback } from '../shared/components/ErrorFallback'
import { wrapRoutesWithRouter } from '../shared/utils/routerPaths'
import { PermissionGuard } from '../shared/components/NoPermission'
import { AccessConfig, homeAccess } from '../shared/permissions'
import { TaskProvider } from '@/modules/shared/context/TaskContext'

const wrappedHomeRoutes = wrapRoutesWithRouter(homeRoutes)


const HOME_ROUTE_GUARDS: Record<string, AccessConfig> = {
  [homeRoutesMap.dashboard]: { require: homeAccess.dashboard },
  [homeRoutesMap.creator]: { require: homeAccess.creator },
}

// Descendant <Routes> in v6 match paths relative to the parent's matched URL.
// Our route config stores absolute paths like `/et/company/:companyId/dashboard`
// — strip the module's homePath prefix so v6 sees relative paths.
const toRelative = (p: string) => {
  const stripped = p.startsWith(homePath) ? p.slice(homePath.length) : p
  return stripped.replace(/^\//, '')
}

const HomeModuleImpl: React.FC = () => {
  const { companyId } = useParams<{ companyId: string }>()

  return (
    <ErrorBoundary
      fallback={(e) => <ErrorFallback error={e.error} onRetry={e.reset} />}
    >
      <TaskProvider>
      <AppLayoutDahboardWithNav>
        <ErrorBoundary
          fallback={(e) => (
            <ErrorFallback error={e.error} onRetry={e.reset} />
          )}
        >
          <HomeLayout companyId={companyId!}>
            <Routes>
              {wrappedHomeRoutes.map((route) => {
                const guard = HOME_ROUTE_GUARDS[route.path]
                const element = guard ? (
                  <PermissionGuard companyId={companyId} {...guard}>
                    <route.Component />
                  </PermissionGuard>
                ) : (
                  <route.Component />
                )

                return (
                  <Route
                    key={route.path}
                    path={`${toRelative(route.path)}/*`}
                    element={element}
                  />
                )
              })}

              {/* fallback */}
              <Route path="*" element={<div>Select</div>} />
            </Routes>
          </HomeLayout>
        </ErrorBoundary>
      </AppLayoutDahboardWithNav>
      </TaskProvider>
    </ErrorBoundary>
  )
}

export const HomeModule = HomeModuleImpl
